import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { API_ENDPOINT } from "../../constants";

export const checkout = createAsyncThunk("checkout", async (data) => {
  try {
    const headers = {
      Accept: "application/json",
      // Altri header se necessario
    };

    if (data.token) {
      headers.tk = `Bearer ${data.token}`;
    }

    const checkoutResponse = await fetch(
      `${API_ENDPOINT}subscriptions/lands/checkout`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data.data),
      }
    );

    console.log("checkoutResponse", checkoutResponse);
    
    if (!checkoutResponse.ok) {
      // Se la risposta non è OK, lanciare un errore con il messaggio dell'API
      const errorData = await checkoutResponse.json();
      throw new Error(`Errore API: ${errorData.message}`);
    }

    console.log("checkoutResponse", checkoutResponse);

    const checkoutData = await checkoutResponse.json();
    return checkoutData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

export const couponCheck = createAsyncThunk("couponCheck", async (data) => {
  console.log("test couponCheck", data);

  try {
    const couponResponse = await fetch(`${API_ENDPOINT}subscriptions/coupon`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        // tk: `Bearer ${data.token}`,
        // Altri header se necessario
      },
      body: JSON.stringify(data),
    });

    const couponData = await couponResponse.json();
    return couponData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

export const couponCheckWallet = createAsyncThunk(
  "couponCheckWallet",
  async (data) => {
    console.log("test couponCheckWallet", data);

    try {
      const couponResponse = await fetch(
        `${API_ENDPOINT}subscriptions/lands/checkout/presale-coupons`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            // tk: `Bearer ${data.token}`,
            // Altri header se necessario
          },
          body: JSON.stringify(data),
        }
      );

      const couponData = await couponResponse.json();
      return couponData;
    } catch (error) {
      throw new Error(
        `Errore durante la richiesta dei dati dell'utente: ${error.message}`
      );
    }
  }
);

export const controllCheckout = createAsyncThunk(
  "controllCheckout",
  async () => {
    console.log("test controllCheckout");

    try {
      const controllCheckoutResponse = await fetch(
        `${API_ENDPOINT}lands/orders`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            // tk: `Bearer ${data.token}`,
            // Altri header se necessario
          },
        }
      );

      const controllCheckoutData = await controllCheckoutResponse.json();
      return controllCheckoutData;
    } catch (error) {
      throw new Error(
        `Errore durante la richiesta dei dati dell'utente: ${error.message}`
      );
    }
  }
);

export const verifyCheckout = createAsyncThunk(
  "verifyCheckout",
  async (data) => {
    console.log("test verifyCheckout", data);

    try {
      const verifyCheckoutResponse = await fetch(
        `${API_ENDPOINT}subscriptions/lands/verify-checkout`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            // tk: `Bearer ${data.token}`,
            // Altri header se necessario
          },
          body: JSON.stringify(data),
        }
      );

      const verifyCheckoutData = await verifyCheckoutResponse.json();
      return verifyCheckoutData;
    } catch (error) {
      throw new Error(
        `Errore durante la richiesta dei dati dell'utente: ${error.message}`
      );
    }
  }
);

const checkoutSlice = createSlice({
  name: "Checkout",
  initialState: {
    isLoading: false,
    isError: false,
    checkout: {},
    coupon: null,
    price: 0,
    newPrice: 0,
    apiResponse: null,
    controllCheckout: null,
    verifyCheckout: null,
  },

  reducers: {
    setPriceRTK: (state, action) => {
      state.price = action.payload;
    },
    setNewPriceRTK: (state, action) => {
      state.newPrice = action.payload;
    },
    addItem: (state, action) => {
      state.push(action.payload);
    },
    resetCheckout: (state) => {
      return {
        ...state,
        checkout: {},
        coupon: null,
        price: null,
        newPrice: null,
        apiResponse: null,
        controllCheckout: null,
        verifyCheckout: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(checkout.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(checkout.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.checkout = action.payload;
      state.apiResponse = { success: true, data: action.payload };
    });
    builder.addCase(checkout.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.apiResponse = { success: false, error: action.error.message };
    });
    builder.addCase(couponCheck.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(couponCheck.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.coupon = action.payload;
    });
    builder.addCase(couponCheck.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(couponCheckWallet.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(couponCheckWallet.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;

      const data = action.payload;
      data.success = data.coupon === null ? false : true;
      state.coupon = data;
    });
    builder.addCase(couponCheckWallet.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(controllCheckout.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(controllCheckout.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.controllCheckout = action.payload;
    });
    builder.addCase(controllCheckout.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(verifyCheckout.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(verifyCheckout.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.verifyCheckout = action.payload;
    });
    builder.addCase(verifyCheckout.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const getItemsSelector = createSelector(
  (state) => state.checkout,
  (state) => state
);

export const { setPriceRTK, setNewPriceRTK, addItem, resetCheckout } =
  checkoutSlice.actions;

export default checkoutSlice.reducer;
